import { useQuery } from '@tanstack/react-query';
import { getBtc15PriceRules } from '../lib/apiClient';

// Settles at most once per 15-minute round; no need to poll faster.
const STALE_TIME_MS = 5 * 60_000;

/** Forward paper test of the pre-registered price-ladder rules. Hypothetical only. */
export function useBtc15PriceRules() {
  return useQuery({
    queryKey: ['btc15-price-rules'],
    queryFn: getBtc15PriceRules,
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });
}
